"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageLoader = void 0;
const seamless_immutable_1 = __importDefault(require("seamless-immutable"));
const fs_1 = __importDefault(require("fs"));
const path_1 = __importDefault(require("path"));
const DEFAULT_LOCALE = 'en-US';
function encodeLocale(locale) {
    if (!locale)
        return null;
    return locale.replace(/-/g, '_');
}
const DEFAULT_COOKIE = 'EPIC_LOCALE';
const messageFileFormat = /messages.*_([a-zA-Z0-9-]+)\.json$/;
const getDirectoryMessages = (directory, files) => {
    const folderMessages = {};
    for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const fileMatch = messageFileFormat.exec(file);
        if (fileMatch) {
            const locale = fileMatch[1];
            folderMessages[locale] = JSON.parse(fs_1.default.readFileSync(path_1.default.join(directory, file), 'utf8'));
        }
    }
    return folderMessages;
};
const addDirectoryToConfig = directory => new Promise(resolve => {
    fs_1.default.readdir(directory, (_, files) => {
        const localeMessages = getDirectoryMessages(directory, files);
        resolve(localeMessages);
    });
});
const addDirectoriesToConfig = (input) => {
    const directories = Array.isArray(input) ? input : [input];
    return directories.map(directory => addDirectoryToConfig(directory));
};
const applyDefaultLocaleMessagesToOtherLocales = localization => {
    const _a = localization, _b = DEFAULT_LOCALE, defaultLocaleMessages = _a[_b], otherMessages = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
    Object.keys(otherMessages).forEach(locale => {
        localization[locale] = Object.assign(Object.assign({}, defaultLocaleMessages), localization[locale]);
    });
};
const mergeMessageBundleResults = messageBundles => {
    if (!messageBundles)
        return {};
    const localization = {};
    for (let i = messageBundles.length - 1; i >= 0; i--) {
        const bundle = messageBundles[i];
        for (const locale in bundle) {
            // eslint-disable-next-line
            if (!bundle.hasOwnProperty(locale))
                continue;
            // eslint-disable-next-line
            if (!localization.hasOwnProperty(locale)) {
                localization[locale] = bundle[locale];
            }
            else {
                Object.assign(localization[locale], bundle[locale]);
            }
        }
    }
    return localization;
};
/**
 * Given one or more directories, load all messages from json files
 */
function MessageLoader(directories, localeConfig) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!localeConfig || !localeConfig.locales) {
            console.error('MessageLoader failed to load locales! localeConfig object parameter with supported "locales" field is required but is invalid!');
            throw new Error('MessageLoader failed to load localization data. Invalid localeConfig');
        }
        const config = {
            localeCookie: localeConfig.localeCookie || DEFAULT_COOKIE,
            DEFAULT_LOCALE: localeConfig.DEFAULT_LOCALE || DEFAULT_LOCALE,
            defaultLocale: localeConfig.DEFAULT_LOCALE || DEFAULT_LOCALE,
            overrideLocales: localeConfig.overrideLocales || {},
            allLocales: localeConfig.overrideLocales ? Object.keys(localeConfig.overrideLocales) : [],
            supportedLocales: []
        };
        localeConfig.locales.forEach(locale => {
            const encodedLocale = encodeLocale(locale);
            if (!config.allLocales.includes(locale)) {
                config.allLocales.push(locale);
                config.supportedLocales.push({
                    name: `epic.header.locale.name.${encodedLocale}`,
                    lang: locale
                });
            }
        });
        return Promise.all(addDirectoriesToConfig(directories)).then(results => {
            // Setup locales to override in order priority [highest, medium, lower, etc]
            const localization = mergeMessageBundleResults(results);
            // Only set messages if the config has locales on it
            if (Object.keys(localization).length > 0) {
                applyDefaultLocaleMessagesToOtherLocales(localization);
                config.localization = { messages: (0, seamless_immutable_1.default)(localization) };
            }
            return config;
        });
    });
}
exports.MessageLoader = MessageLoader;
//# sourceMappingURL=MessageLoader.js.map